import {connect} from 'react-redux';

import {randomString} from '../../../../../libs/shared/helpers/src/utilities/stringHelpers';
import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {
  createSchedulingCalendarsPanelTransitionAction,
  updateStandardAvailabilityAction,
} from '../../../../store/panels/calendars/scheduling/calendarsPanelSchedulingActions';
import {
  getDidEditDraftSchedulingLink,
  getSchedulingPanelShouldForcePopout,
  getSelectedStandardSlots,
} from '../../../../store/panels/calendars/scheduling/calendarsPanelSchedulingSelectors';
import {CalendarsPanelId, ComposerPanelId, ViewerPanelId} from '../../../../store/panels/panelStateBase';
import {inLegacyTransientPanel} from '../../../legacyTransientPanel';
import {MeetingTimesDialog, MeetingTimesDialogPublicProps} from './meetingTimesDialog';

/*
 * Props.
 */

interface MeetingTimesDialogContainerProps extends MeetingTimesDialogPublicProps {
  panelId: CalendarsPanelId;
  parentPanelId: CalendarsPanelId | ComposerPanelId | ViewerPanelId;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<MeetingTimesDialogContainerProps>()(() => ({
  didEditDraft: getDidEditDraftSchedulingLink,
  shouldForcePopout: getSchedulingPanelShouldForcePopout,
  selectedSlots: getSelectedStandardSlots,
}));

const mapDispatchToProps = makeMapDispatchToProps<MeetingTimesDialogContainerProps>()(({panelId}) => ({
  onUpdateSelectedSlots: (newSlots) => updateStandardAvailabilityAction(panelId, newSlots),
}));

/*
 * Panel.
 */

export const MeetingTimesDialogContainer = inLegacyTransientPanel(
  connect(mapStateToProps, mapDispatchToProps)(MeetingTimesDialog),
  ({panelId, parentPanelId, schedulingLinkId}) =>
    createSchedulingCalendarsPanelTransitionAction(panelId, parentPanelId, schedulingLinkId, {
      slug: randomString(8),
      isOneTimeLink: true,
    }),
);
